//@ts-nocheck
import { writable } from 'svelte/store'
import user from '$lib/stores/user'
import { API_URL } from './conf'
// constants
export const regexEmail =
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/g
export const regexTel = /\+[0-9]{1,}\s[0-9]{3,}\s[0-9|\s|-]{6,}/
export const uuidPattern =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/
export const capitalizedPattern = /^[A-ZÁÉÍÑÓÚ][a-záéíóúñ]{0,}$/g
export const urlPattern =
    /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)/gi
export const coordinatesPattern =
    /^\s*(?<lat>-{0,1}[0-9]+\.{0,1}[0-9]*)\s*[,|;|\s]\s*(?<lng>-{0,1}[0-9]+\.{0,1}[0-9]*)\s*$/gi

export const daysOfWeek = {
    en: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ],
    es: [
        'Domingo',
        'Lunes',
        'Martes',
        'Miércoles',
        'Jueves',
        'Viernes',
        'Sábado',
    ],
}
export const monthsOfYear = {
    en: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ],
    es: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
    ],
}

// Custom Events
export function clickOutside(node) {
    const handleClick = (event) => {
        if (node && !node.contains(event.target) && !event.defaultPrevented) {
            node.dispatchEvent(new CustomEvent('clickout', node))
        }
    }
    document.addEventListener('click', handleClick, true)
    return {
        destroy() {
            document.removeEventListener('click', handleClick, true)
        },
    }
}
export function clickOutsideParent(node) {
    const handleClick = (event) => {
        if (node && !node.contains(event.target) && !event.defaultPrevented) {
            node.dispatchEvent(new CustomEvent('clickout', node))
        }
    }
    const parent = node.parentElement
    parent.addEventListener('click', handleClick, true)
    return {
        destroy() {
            parent.removeEventListener('click', handleClick, true)
        },
    }
}
// Custom functions
export function getCSSVar(v) {
    var style = getComputedStyle(document.body)
    return style.getPropertyValue(v)
}

// export function sortBy(element, keys, asc=false){
//   let ret = [...element];
//   for(let key of keys){
//     ret.sort((a, b) => {return a[key] > b[key] ? -1 : 1})
//   }
//   return asc ? ret.reverse() : ret;
// }

export function sortBy(element, keys, schema=null) {
    let ret = [...element]
    for (let key of keys) {
        let asc = key[0] !== '-'
        let k = asc ? key : key.slice(1)
        let isVirtualField = schema && k in schema ? schema[k]?.virtual || false : false
        let ck = schema && k in schema && isVirtualField && ['render', 'value'].some(attr => attr in schema[k]) ? (
            'value' in schema[k] ? (r) => schema[k]?.value(r) : (r) => schema[k]?.render(null, r)
        ) : k
        ret.sort((a, b) => {
            return resolveObjectKey(ck, a) > resolveObjectKey(ck, b)
                ? asc
                    ? -1
                    : 1
                : asc
                  ? 1
                  : -1
        })
    }
    return ret
}

export const currencyFormatter = ({ n, lang = 'es-ES', type = 'USD' }) =>
    new Intl.NumberFormat(lang, { style: 'currency', currency: type }).format(
        typeof n == 'number' ? n : parseFloat(n)
    )

function objToArray(obj) {
    let allAreNumber = Object.keys(obj).every((a) => !isNaN(parseInt(a)))
    let complete = Array(Math.max(...Object.keys(obj)))
        .fill()
        .map((_, i) => i)
        .every((p) => `${p}` in obj)
    if (allAreNumber && complete) {
        return Object.entries(obj)
            .sort((a, b) => a > b)
            .map(([_, v]) => v)
    }
    return obj
}

export function flattenObject(obj) {
    let flattened = {}
    for (let key in obj) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
            let flatObj = flattenObject(obj[key])
            for (let subKey in flatObj) {
                flattened[key + '.' + subKey] = flatObj[subKey]
            }
        } else {
            flattened[key] = obj[key]
        }
    }
    return flattened
}

export function unflattenObject(obj) {
    let unflattened = {}
    for (let key in obj) {
        let value = obj[key]
        let keys = key.split('.')
        let currentObj = unflattened
        for (let i = 0; i < keys.length - 1; i++) {
            let currentKey = keys[i]
            if (
                !currentObj[currentKey] ||
                typeof currentObj[currentKey] !== 'object'
            ) {
                // Crear objeto o array vacío si el valor anterior no existe o no es un objeto
                if (Number.isInteger(Number(keys[i + 1]))) {
                    currentObj[currentKey] = []
                } else {
                    currentObj[currentKey] = {}
                }
            }
            currentObj = currentObj[currentKey]
        }
        let lastKey = keys[keys.length - 1]
        if (Number.isInteger(Number(lastKey))) {
            // Convertir la clave a un número si es un índice numérico
            lastKey = Number(lastKey)
        }
        if (typeof value === 'object' && !Array.isArray(value)) {
            // Si el valor es un objeto, aplicar recursividad
            currentObj[lastKey] = unflattenObject(value)
        } else {
            currentObj[lastKey] = value
        }
    }
    return objToArray(unflattened)
}

export function areEquals(...objs) {
    let lastObj = objs[0]
    return objs.slice(1).reduce((res, obj) => {
        let ret = typeof lastObj === typeof obj
        if (ret) {
            let objt = flattenObject(lastObj)
            lastObj = obj
            obj = flattenObject(obj)
            ret = Object.entries(objt).every(
                ([k, v]) => k in obj && v === obj[k]
            )
        }
        return ret
    }, lastObj)
}

// export function areIdenticals(...obj, { ignoreFields=[] }){
//   let lastObj = objs[0]
//   return objs.slice(1).reduce((res, obj) => {
//     let ret = typeof lastObj === typeof obj
//     if(ret) {
//       let objt = flattenObject(lastObj)
//       obj = flattenObject(obj)
//       ret = Object.entries(objt)
//       .filter(([k]) => !ignoreFields.includes(k))
//       .every(([k, v]) => k in obj && v === obj[k])
//       lastObj = obj
//     }
//     return ret
//   }, lastObj)
// }

export const truncate = (str, n = 20, center = false) => {
    let len = str.length
    let truncable = len > n
    if (center) {
        return truncable
            ? str.substr(0, Math.floor((n - 1) / 2)) +
                  '...' +
                  str.substr(Math.floor(((n - 2) / 2) * -1))
            : str
    } else {
        return truncable ? str.substr(0, n - 3) + '...' : str
    }
}

export const formatCUIT = (cuit) => {
    return `${cuit.slice(0, 2)} - ${cuit.slice(2, -1)} - ${cuit.slice(-1)}`
}

export const randint = (a, b = undefined) => {
    let st,
        ed,
        single = b === undefined
    st = single ? 0 : a
    ed = single ? a : b
    return st + Math.round(Math.random() * (ed - st))
}
export const calcularCuit = (
    doc,
    male = false,
    female = false,
    society = false
) => {
    if ((male ? 1 : 0) ^ (female ? 1 : 0) ^ (society ? 1 : 0)) {
        let prefix = [
            [male, '20'],
            [female, '27'],
            [society, '30'],
        ].reduce((r, [cond, value]) => {
            return r ? r : cond ? value : r
        }, false)
        console.log(prefix)
        let base = prefix + doc
        let suma = base
            .split('')
            .reduce(
                (a, b, i) =>
                    a + [5, 4, 3, 2, 7, 6, 5, 4, 3, 2][i] * parseInt(b),
                0
            )
        let resto = suma % 11
        let Z
        if (resto === 0) {
            Z = 0
        } else if (resto === 1) {
            Z = male ? 9 : female ? 4 : -1
            prefix = '23'
        } else {
            Z = 11 - resto
        }
        return prefix + base + String(Z)
    } else {
        return null
    }
}
export const validarCuit = (cuit) => {
    cuit = cuit?.replace(/-|\s/g, '') || ''
    if (cuit.length >= 11) {
        let xy = cuit.slice(0, 2)
        let doc = cuit.slice(2, -1)
        let suma = (xy + doc)
            .split('')
            .reduce(
                (a, b, i) =>
                    a + [5, 4, 3, 2, 7, 6, 5, 4, 3, 2][i] * parseInt(b),
                0
            )
        let resto = suma % 11
        let Z
        if (resto === 0) {
            Z = 0
        } else if ([9, 4].includes(resto) && xy === '23') {
            Z = parseInt(cuit.slice(-1))
        } else {
            Z = 11 - resto
        }
        return parseInt(cuit.slice(-1)) === Z
    } else {
        return false
    }
}
export const validarNoNull = (n) => !['', null, undefined].includes(n)
function validationDocBuilder(allowMediaType = ['pdf']) {
    return (d) => {
        let rgx = new RegExp(`^.*\.(${allowMediaType.join('|')})$`, 'i')
        return (
            d instanceof Array &&
            d.length > 0 &&
            d.every((f) => rgx.test(f?.filename) || false)
        )
    }
}
export const validarDocPDF = validationDocBuilder()
export const validarImporte = (v) => v && /^[0-9]+(\.[0-9]{1,2})?$/.test(v)
export const telValidation = (n) => n.match(/[0-9|\-|\s]{8,17}$/)
export const validarTelefono = (n) => {
    let match = typeof n === 'string' && n.match(/\d/g)
    let nums = match ? match.length : null
    return (
        typeof nums == 'number' &&
        /^\+?\d[\d|\s|\-]{8,17}$/.test(n) &&
        nums >= 10 &&
        nums <= 14
    )
}
export function validarCbu(cbu, bankId = undefined, office = undefined) {
    if (cbu.length === 22) {
        // Bloque1
        let block1 = cbu.slice(0, 8)
        let block2 = cbu.slice(8)
        let sumab1 = new String(
            block1
                .slice(0, -1)
                .split('')
                .reduce(
                    (a, b, i) => a + parseInt(b) * [7, 1, 3, 9, 7, 1, 3][i],
                    0
                )
        )
        let sumab2 = new String(
            block2
                .slice(0, -1)
                .split('')
                .reduce(
                    (a, b, i) =>
                        a +
                        parseInt(b) *
                            [3, 9, 7, 1, 3, 9, 7, 1, 3, 9, 7, 1, 3][i],
                    0
                )
        )
        if (
            (10 - parseInt(sumab1.slice(-1))) % 10 ===
            parseInt(block1.slice(-1))
        ) {
            // Bloque2
            let ret =
                (10 - parseInt(sumab2.slice(-1))) % 10 ===
                parseInt(block2.slice(-1))
            // validations
            ret = bankId ? bankId === block1.slice(0, 3) && ret : ret
            ret = office
                ? parseInt(office) === parseInt(block1.slice(3, 7)) && ret
                : ret
            return ret
        } else {
            return false
        }
    } else {
        return false
    }
}
export function validarNroCuenta(nro) {
    // EEEE0000DDNNNNNNNNNN
    if (nro.length >= 10) {
        let bankCode = nro.slice(0, 4),
            officeCode = nro.slice(4, 8),
            [c1, c2] = nro.slice(8, 10),
            account = nro.slice(10)
        let suma1 = (bankCode + officeCode)
                .split('')
                .reduce(
                    (a, b, i) => a + parseInt(b) * [4, 8, 5, 10, 9, 7, 3, 6][i],
                    0
                ),
            suma2 = account
                .split('')
                .reduce(
                    (a, b, i) =>
                        a + parseInt(b) * [1, 2, 4, 8, 5, 10, 9, 7, 3, 6][i],
                    0
                )
        let r1 = 11 - (suma1 % 11),
            r2 = 11 - (suma2 % 11)
        return r1 === parseInt(c1) && r2 === parseInt(c2)
    } else {
        return false
    }
}
export function validarCp(cp) {
    return (
        typeof cp === 'string' &&
        cp.match(/^[A-z][0-9]{4}[A-z]{3}$|^[0-9]{4}$|^[A-z][0-9]{4}$/) !== null
    )
}
export function validarDni(dni) {
    return typeof dni === 'string' && dni.match(/^[0-9]{7,8}$/) !== null
}
export function validarLibreta(nro) {
    return typeof nro === 'string' && nro.match(/^[0-9]{7,8}$/) !== null
}
export const validateDoc =
    (type = null) =>
    (n) =>
        type
            ? {
                  /* Valores viejos */
                  1: validarDni,
                  2: validarCuit,
                  3: validarCuit,
                  4: validarLibreta,
                  5: validarLibreta,
                  /* Valores nuevos */
                  96: validarDni,
                  80: validarCuit,
                  86: validarCuit,
                  90: validarLibreta,
                  89: validarLibreta,
              }[type](n)
            : (_) => false

export function range(st, ed = null, step = 1) {
    if (ed === null) {
        ed = st
        st = 0
    }
    let ret = []
    for (let i = st; i < ed; i += step) {
        ret.push(i)
    }
    return ret
}
export function validateEmail(email) {
    return (
        email &&
        email.toLowerCase().match(regexEmail) &&
        [','].every((x) => email.indexOf(x) === -1) &&
        (email.indexOf('@') !== -1
            ? email.split('@').at(-1).split('.').length <= 4
            : false) &&
        (email.indexOf('@') !== -1
            ? email
                  .split('@')
                  .at(-1)
                  .split('.')
                  .every((c) => c.length >= 2)
            : false)
    )
}

const notNull = (str) =>
    ![null, undefined, ''].includes(str) && typeof str == 'string'

export const isPdf = (str) => str && /^.+\.pdf$/gi.test(str)

export const isAsync = (x) => x?.constructor?.name == 'AsyncFunction'

export const sleep = (ms) =>
    new Promise((ok) => {
        setTimeout(() => ok(), ms)
    })

export function resolveObjectKey(key, obj, clone = false) {
    let tmp = clone ? structuredClone(obj) : obj
    if (typeof key == 'string') {
        for (let k of key.split('.')) {
            tmp = tmp[k]
            if (tmp === undefined) break
        }
    } else if (typeof key == 'function') {
        return key(obj)
    }
    return tmp
}

export function resolveFormfields(providerData) {
    let passed = []
    let noPassed = []
    let validations = {
        ...(providerData.persona_jur_dp
            ? {
                  denominacion_dp: notNull,
                  // 'nombre_fantasia_dp': notNull
              }
            : {
                  nombre_dp: notNull,
                  apellido_dp: notNull,
              }),
        tipo_doc_dp: notNull,
        no_doc_dp: validateDoc(providerData.tipo_doc_dp),
        localidad_dp: notNull,
        actividad_principal_dp: notNull,
        domicilio_dp: notNull,
        localidad_dp: notNull,
        cp_dp: validarCp,
        tel_dp: telValidation,
        email_dp: (e) => validateEmail(e) && !['', null, undefined].includes(e),
        cuit_ii: validarCuit,
        tipo_proveedor_ii: notNull,
        condicion_imp_iva_ii: notNull,
        condicion_imp_ganancias_ii: notNull,
        condicion_imp_ingresos_ii: notNull,
        no_ingresos_brutos_ii: (n) =>
            typeof n === 'string' && n.match(/^([0-9])*$/),
        empleador_ii:
            providerData.condicion_imp_iva_ii === '1' ? notNull : (_) => true,
        // ...(
        //   ['', undefined, null].includes(providerData.tiene_personal_lp) ? {
        //     'tiene_personal_lp': notNull
        //   } :
        //   (providerData.tiene_personal_lp == '1' ? {'personal_lp': notNull} : {})
        // ),
        titular_ac: notNull,
        cbu_ac: (s) => validarCbu(s, providerData.banco_ac),
        domicilio_ac: notNull,
        cuit_ac: validarCuit,
        // 'banco_ac': s => (new RegExp('[0-9]{3}')).match(s),
        banco_ac: notNull,
        tel_ac: telValidation,
        email_ac: validateEmail,
        presentado_ac: notNull,
        no_doc_ac: (s) => validateDoc(providerData.tipo_doc_ac)(s),
        tipo_doc_ac: notNull,
    }
    Object.entries(providerData).forEach(([key, value]) => {
        let validation = key in validations ? validations[key] : (s) => true

        if (validation(value)) {
            passed.push(key)
        } else {
            noPassed.push(key)
        }
    })
    return [passed, noPassed]
}
// String
export function stringSimilarity(
    str1,
    str2,
    substringLength = 2,
    caseSensitive = false
) {
    str1 = removeAccents(str1)
    str2 = removeAccents(str2)
    if (!caseSensitive) {
        str1 = str1.toLowerCase()
        str2 = str2.toLowerCase()
    }

    if (str1.length < substringLength || str2.length < substringLength) return 0

    const map = new Map()
    for (let i = 0; i < str1.length - (substringLength - 1); i++) {
        const substr1 = str1.substr(i, substringLength)
        map.set(substr1, map.has(substr1) ? map.get(substr1) + 1 : 1)
    }

    let match = 0
    for (let j = 0; j < str2.length - (substringLength - 1); j++) {
        const substr2 = str2.substr(j, substringLength)
        const count = map.has(substr2) ? map.get(substr2) : 0
        if (count > 0) {
            map.set(substr2, count - 1)
            match++
        }
    }
    return (match * 2) / (str1.length + str2.length - (substringLength - 1) * 2)
}

export function solveAccents(input) {
    let ret = `${input}`
    let replacer =
        ret.match(/\w+cion/g)?.map((x) => [x, x.replace('cion', 'ción')]) || []
    replacer.concat(
        ret.match(/\w+sion/g)?.map((x) => [x, x.replace('sion', 'sión')]) || []
    )
    if (replacer instanceof Array) {
        ret = replacer.reduce((i, [m, r]) => {
            return i.replace(m, r)
        }, ret)
    }
    // if (sion instanceof Array){ ret = sion.reduce((i, [m, r]) => {return i.replace(m, r)}, ret) }
    return ret
}
export const ord = (s) => s.charCodeAt()
export const chr = (n) => String.fromCharCode(n)

export function latinToASCII(c) {
    let r = c
    for (let [k, v] of Object.entries(latinEquiv)) {
        if (v.indexOf(c) !== -1) {
            r = k
            break
        }
    }
    return r
}

export function removeAccents(input) {
    return input
        .split('')
        .map((x) => latinToASCII(x))
        .join('')
}

export function isCapitaliced(str) {
    return capitalizedPattern.test(str)
}

export function readAthTable(ocs) {
    try {
        let ret = JSON.parse(
            ocs
                .replace(/u\'/g, "'")
                .replace(/"/g, '\\"')
                .replace(/\'/g, '"')
                .replace(/\n/g, '')
                .replace(/[\s]+/g, ' ')
        )
        return ret || undefined
    } catch {
        return []
    }
}

export function searchFilterSimilarity(haystack, needle, threshold = 0.5) {
    let sum = haystack
        .toLowerCase()
        .split(' ')
        .map((a) => stringSimilarity(a, needle))
    return sum.some((a) => a >= threshold)
}

export function capitalize(string, all = false) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}
export function toTitleCase(string) {
    return string
        .split(' ')
        .map((str) => capitalize(str))
        .join(' ')
}

export async function getBlobURL(url) {
    const response = await fetch(url)
    const blob = await response.blob()
    return URL.createObjectURL(blob)
}

export function fakeFetch({
    min = 200,
    max = 1000,
    umbral = 0.5,
    resolveValue = true,
    rejectValue = false,
}) {
    return new Promise((resolve, reject) => {
        setTimeout(
            (_) => {
                if (Math.random() > 1 - umbral) {
                    resolve(new FakeResponse(resolveValue, true))
                } else {
                    reject(new FakeResponse(rejectValue, false))
                }
            },
            min + Math.random() * (max - min)
        )
    })
}
export function randomChar(length) {
    let result = ''
    const characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    const charactersLength = characters.length
    let counter = 0
    while (counter < length) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        )
        counter += 1
    }
    return result
}

export function hashString(msg, entropy = false) {
    var hash = 0,
        i,
        chr
    let str = `${JSON.stringify(msg)}${entropy ? randomChar(15) : ''}`
    if (str.length === 0) return hash
    for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i)
        hash = (hash << 5) - hash + chr
        hash |= 0 // Convert to 32bit integer
    }
    return hash
}

const timeEquiv = {
    w: 604800,
    d: 86400,
    h: 3600,
    m: 60,
    s: 1,
    i: 1 / 1000,
}

export function parseTime(str, d = 's') {
    let rgx = new RegExp(
        `((?<value>\\d+)(?<unit>[${Object.keys(timeEquiv).join('')}]))`,
        'g'
    )
    let ret = [...str.toLowerCase().matchAll(rgx)]
        .map(({ groups: { value, unit } }) => [value, unit])
        .reduce((r, [v, k]) => r + parseInt(v) * timeEquiv[k], 0)
    return ret * (d in timeEquiv ? 1 / timeEquiv[d] : 1)
}

export function timeParse(delta, template = '%H:%M') {
    const operator = {
        W: timeEquiv.w,
        d: timeEquiv.d,
        H: timeEquiv.h,
        M: timeEquiv.m,
        s: timeEquiv.s,
        i: timeEquiv.i,
    }
    let rgx = new RegExp(`%-{0,1}[${Object.keys(operator).join('')}]`, 'g')
    return [...template.matchAll(rgx)]
        .map(([x]) => [x[1] === '-', x.at(-1)])
        .reduce((ret, [pad, key]) => {
            if (key in operator) {
                let value = 0
                if (delta >= operator[key]) {
                    value = Math.floor(delta / operator[key])
                    delta -= value * operator[key]
                }
                ret = ret.replace(
                    new RegExp(`%${pad ? '-' : ''}${key}`, 'g'),
                    String(value).padStart(pad ? 0 : 2, '0')
                )
                return ret
            } else {
                return ret
            }
        }, template)
}
/**
 * Esta funcion devuelve la diferencia (en segundos) entre dos fechas
 * @param {Date} date - Primera fecha
 * @param {Date} dateb - Segunda fecha
 * @param {string|null} template - Template (timeParse)
 * @returns {number} - The sum of numOne and numTwo
 */
export function getDiffDate(date, dateb) {
    if (date === null) date = new Date(0)
    let ret = (date.getTime() - dateb.getTime()) / 1000
    return ret
}

export function getRelTime(date, compareDate = null) {
    let now = compareDate || new Date()
    let [tn, td] = [now.getTime(), date.getTime()]
    let diff = Math.floor((tn - td) / 1000)
    if (diff <= parseTime('1m')) {
        // Hace un momento
        return 'Hace un momento'
    } else if (diff <= parseTime('1h')) {
        // Hace x minutos
        let r = (now.getTime() - date.getTime()) / 1000
        return `Hace ${Math.floor(r / 60)} minutos`
    } else if (strftime('%Y-%m-%d', now) === strftime('%Y-%m-%d', date)) {
        // Hoy
        return strftime('%H:%M', date)
    } else if (
        strftime('%Y-%m', now) == strftime('%Y-%m', date) &&
        now.getDate() - date.getDate() === 1
    ) {
        // Ayer
        return strftime('Ayer, %H:%M', date)
    } else if (diff < parseTime('7d')) {
        // Misma semana
        return strftime('%A %H:%M', date)
    } else if (strftime('%Y-%m', now) == strftime('%Y-%m', date)) {
        // Mismo mes
        return strftime('%A %d a las %H:%M', date)
    }
    return strftime('%d/%m/%Y %H:%M', date)
}

export function getLocationFromAth(str) {
    coordinatesPattern.lastIndex = 0
    let ret = { lat: null, lng: null }
    let match = coordinatesPattern.exec(str)
    if (match) {
        ret = {
            lat: match?.groups?.lat ? parseFloat(match.groups.lat) : null,
            lng: match?.groups?.lng ? parseFloat(match.groups.lng) : null,
        }
    }
    return ret
}

export function strftime(template = '', date = null, lang = 'es') {
    date = date ?? new Date()
    lang = lang in daysOfWeek ? lang : 'en'
    if (typeof date == 'string') date = getDateObj(date)
    const format = (i, n = 2) => String(i).padStart(n, '0')
    const replacer = {
        Y: (_) => String(date.getFullYear()),
        y: (_) => String(date.getYear()).slice(-2),
        m: (np) => format(date.getMonth() + 1, np ? 0 : 2),
        d: (np) => format(date.getDate(), np ? 0 : 2),
        w: (_) => format(date.getDay()),
        j: (np) =>
            format(
                timeParse(
                    getDiffDate(date, new Date(date.getFullYear(), 0, 0)),
                    '%d'
                ),
                np ? 0 : 3
            ),
        H: (np) => format(date.getHours(), np ? 0 : 2),
        I: (np) => {
            let h = date.getHours() - 12
            return format(h <= 0 ? h + 12 : h, np ? 0 : 2)
        },
        p: (_) => (date.getHours() <= 12 ? 'AM' : 'PM'),
        M: (np) => format(date.getMinutes(), np ? 0 : 2),
        s: (np) => format(date.getSeconds(), np ? 0 : 2),
        z: (_) => {
            let m = date.getTimezoneOffset()
            return format(timeParse(m * 60, `${m >= 0 ? '+' : '-'}%H:%M`))
        },
        a: (_) => daysOfWeek[lang][date.getDay()].slice(0, 3),
        A: (_) => daysOfWeek[lang][date.getDay()],
        b: (_) => monthsOfYear[lang][date.getMonth()].slice(0, 3),
        B: (_) => monthsOfYear[lang][date.getMonth()],
        '%': () => '%',
    }
    const rgx = new RegExp(`%\\-{0,1}[${Object.keys(replacer).join('')}]`, 'g')
    return [...template.matchAll(rgx)]
        .map(([k]) => k)
        .reduce((r, c) => {
            let l = c.at(-1)
            let np = c.indexOf('-') !== -1
            let func = l in replacer ? replacer[l] : null
            let rx = new RegExp(`${c}`, 'g')
            return func ? r.replace(rx, func(np)) : r
        }, template)
}

export function completeISODateString(date, gmt = null) {
    let template = '1970-01-01T00:00:00.000'
    if (gmt === null) gmt = -1 * (new Date().getTimezoneOffset() / 60)
    if (gmt !== 0) {
        template +=
            (gmt < 0 ? '-' : '+') +
            String(Math.ceil(Math.abs(gmt) * 100)).padStart(4, '0')
    } else {
        template += 'Z'
    }
    return date ? date + template.slice(date.length) : template
}

export function getDateObj(i, gmt = 0) {
    let ret = null
    switch (typeof i) {
        case 'string':
            if (/^\d{4}.\d{2}.\d{2}$/.test(i)) {
                i = completeISODateString(i.split(/-|\//).join('-'), gmt)
            } else if (/^\d{2}.\d{2}.\d{4}$/.test(i)) {
                i = completeISODateString(
                    i.split(/-|\//).reverse().join('-'),
                    gmt
                )
            } else if (
                /^\d{2}.\d{2}.\d{4}\s\d+\:\d+(\:\d+\.{0,1}\d{0,}){0,1}$/.test(i)
            ) {
                let [date, time] = i.split(' ')
                i = completeISODateString(
                    date.split(/-|\//).reverse().join('-') +
                        'T' +
                        time
                            .split(':')
                            .map((h) => (h.length < 2 ? h.padStart(2, '0') : h))
                            .join(':'),
                    gmt
                )
            } else if (
                /^\d{4}.\d{2}.\d{2}\s\d+\:\d+(\:\d+\.{0,1}\d{0,3}){0,1}$/.test(
                    i
                )
            ) {
                let [date, time] = i.split(' ')
                i = completeISODateString(
                    date.split(/-|\//).join('-') +
                        'T' +
                        time
                            .split(':')
                            .map((h) => (h.length < 2 ? h.padStart(2, '0') : h))
                            .join(':'),
                    gmt
                )
            }
            ret = i
            break
        case 'number':
            ret = i < 1e12 ? i * 1000 : i
        default:
            break
    }
    return ret ? new Date(ret) : null
}

const latinEquiv = {
    // Ver https://www.compart.com/en/unicode
    // Array(...document.querySelectorAll('a.content-item.card > p.text')).map(a => a.innerHTML).join('')
    a: 'ªàáâãäåāăąǎȁȃȧᵃḁẚạảₐ℀℁⒜ⓐ㏂ａ𝐚𝑎𝒂𝒶𝓪𝔞𝕒𝖆𝖺𝗮𝘢𝙖𝚊',
    A: 'ÀÁÂÃÄÅĀĂĄǍȀȂȦᴬḀẠẢⒶＡ𝐀𝐴𝑨𝒜𝓐𝔄𝔸𝕬𝖠𝗔𝘈𝘼𝙰🄐🄰',
    e: 'èéêëēĕėęěȅȇȩᵉḙḛẹẻẽₑℯⅇ⒠ⓔｅ𝐞𝑒𝒆𝓮𝔢𝕖𝖊𝖾𝗲𝘦𝙚𝚎',
    E: 'ÈÉÊËĒĔĖĘĚȄȆȨᴱḘḚẸẺẼℰⒺＥ𝐄𝐸𝑬𝓔𝔈𝔼𝕰𝖤𝗘𝘌𝙀𝙴🄔🄴',
    i: 'ìíîïĩīĭįĳǐȉȋᵢḭỉịⁱℹⅈⅰ⒤ⓘ㏌㏕ﬁﬃｉ𝐢𝑖𝒊𝒾𝓲𝔦𝕚𝖎𝗂𝗶𝘪𝙞𝚒',
    I: 'ÌÍÎÏĨĪĬĮİĲǏȈȊᴵḬỈỊℐℑⅠⒾＩ𝐈𝐼𝑰𝓘𝕀𝕴𝖨𝗜𝘐𝙄𝙸🄘🄸',
    o: 'ºòóôõöōŏőơǒǫȍȏȯᵒọỏₒℴ⒪ⓞｏ𝐨𝑜𝒐𝓸𝔬𝕠𝖔𝗈𝗼𝘰𝙤𝚘',
    O: 'ÒÓÔÕÖŌŎŐƠǑǪȌȎȮᴼỌỎⓄＯ𝐎𝑂𝑶𝒪𝓞𝔒𝕆𝕺𝖮𝗢𝘖𝙊𝙾🄞🄾',
    u: 'ùúûüũūŭůűųưǔȕȗᵘᵤṳṵṷụủ⒰ⓤｕ𝐮𝑢𝒖𝓊𝓾𝔲𝕦𝖚𝗎𝘂𝘶𝙪𝚞',
    U: 'ÙÚÛÜŨŪŬŮŰŲƯǓȔȖᵁṲṴṶỤỦⓊＵ𝐔𝑈𝑼𝒰𝓤𝔘𝕌𝖀𝖴𝗨𝘜𝙐𝚄🄤🅄',
    n: 'ñńņňŉǌǹṅṇṉṋⁿₙ⒩ⓝｎ𝐧𝑛𝒏𝓃𝓷𝔫𝕟𝖓𝗇𝗻𝘯𝙣𝚗',
    N: 'ÑŃŅŇǊǋǸᴺṄṆṈṊℕⓃＮ𝐍𝑁𝑵𝒩𝓝𝔑𝕹𝖭𝗡𝘕𝙉𝙽🄝🄽',
    y: 'ýÿŷȳʸẏẙỳỵỷỹ⒴ⓨｙ𝐲𝑦𝒚𝓎𝔂𝔶𝕪𝖞𝗒𝘆𝘺𝙮𝚢',
    Y: 'ÝŶŸȲẎỲỴỶỸⓎＹ𝐘𝑌𝒀𝒴𝓨𝔜𝕐𝖄𝖸𝗬𝘠𝙔𝚈🄨🅈',
}

// Store
export const createVirtualList = (initial = [], index = 0) => {
    const { subscribe, set, update } = writable(
        initial instanceof Array ? initial : []
    )
    let count = index
    return {
        subscribe,
        set,
        add: (item = {}) => update((d) => [...d, { id: count++, ...item }]),
        get: (id) => {
            let ret
            subscribe((d) => (ret = d.find((x) => x.id === id)))
            return ret
        },
        update: (id, content, replace = false) =>
            update((d) =>
                d.map((x) =>
                    x.id !== id
                        ? x
                        : replace
                          ? { id, ...content }
                          : { ...x, ...content }
                )
            ),
        delete: (id) => update((d) => d.filter((x) => x.id !== id)),
        clear: (_) => set([]),
    }
}

export const areasOrder = [
    'Retribuciones y control gestión operativa',
    'Activo Fijo',
    'Tecnología Informática',
    'Marketing',
    'Servicios internos',
    'Siniestros legales y extrajudiciales',
    'Siniestros Motor',
    'Siniestros vida y generales',
    'Administración y control cartera',
    'Comercial',
    'Recursos Humanos',
    'Capacitación y Desarrollo',
    'Contabilidad',
    'Impuestos',
    'Inversiones',
    'Tesorería',
    'Siniestros',
    'Técnica',
    'Técnica de Vida',
    'Técnica Autos',
    'Técnica Generales',
    'Asuntos Jurídicos',
    'Asuntos Societarios',
    'Auditoría',
    'Riesgos',
    'Técnica Pricing',
    'Seguridad Física',
    'Compliance',
    'GC & C',
    'Direccion CEO',
    'Cancelacion Debitos de Compras',
    'Servicios de cobranzas(PDU, FEE, Administracion)',
    'Automatización de Procesos',
    'IS1 - Impuestos de sellos',
    'Finanzas',
    'RT1 - Retribuciones a terceros',
]

// Custom classes
export class Datetime {
    constructor(
        a = undefined,
        b = undefined,
        c = undefined,
        d = undefined,
        e = undefined,
        f = undefined,
        g = undefined
    ) {
        let args = [a, b, c, d, e, f, g]
        let pos = args.findIndex((x) => x === undefined)
        // console.log(pos, args, args.slice(0, pos));
        if (pos === 0) {
            this.date = new Date()
        } else {
            // @ts-ignore
            this.date = new Date(...args.slice(0, pos))
        }
        if (this.date) {
            this.day = this.getDate()
            this.year = this.getFullYear()
            this.month = this.getMonth() + 1
            this.dayOfWeak = this.getDay()
        }
    }
    getDate() {
        return this.date.getDate()
    }
    getDay() {
        return this.date.getDay()
    }
    getFullYear() {
        return this.date.getFullYear()
    }
    getHours() {
        return this.date.getHours()
    }
    getMilliseconds() {
        return this.date.getMilliseconds()
    }
    getMinutes() {
        return this.date.getMinutes()
    }
    getMonth() {
        return this.date.getMonth()
    }
    getSeconds() {
        return this.date.getSeconds()
    }
    getTime() {
        return this.date.getTime()
    }
    getUTCDate() {
        return this.date.getUTCDate()
    }
    getUTCMinutes() {
        return this.date.getUTCMinutes()
    }
    setFullYear(n) {
        return this.date.setFullYear(n)
    }
    setSeconds(n) {
        return this.date.setSeconds(n)
    }
    setUTCMilliseconds(n) {
        return this.date.setUTCMilliseconds(n)
    }
    toDateString() {
        return this.date.toDateString()
    }
    toLocaleString() {
        return this.date.toLocaleString()
    }
    valueOf() {
        return this.date.valueOf()
    }
    getTimezoneOffset() {
        return this.date.getTimezoneOffset()
    }
    getUTCDay() {
        return this.date.getUTCDay()
    }
    getUTCFullYear() {
        return this.date.getUTCFullYear()
    }
    getUTCHours() {
        return this.date.getUTCHours()
    }
    getUTCMilliseconds() {
        return this.date.getUTCMilliseconds()
    }
    getUTCMonth() {
        return this.date.getUTCMonth()
    }
    getUTCSeconds() {
        return this.date.getUTCSeconds()
    }
    // @ts-ignore
    getYear() {
        return this.date.getYear()
    }
    // @ts-ignore
    setDate() {
        return this.date.setDate()
    }
    // @ts-ignore
    setHours() {
        return this.date.setHours()
    }
    setMilliseconds(n) {
        return this.date.setMilliseconds(n)
    }
    setMinutes(n) {
        return this.date.setMinutes(n)
    }
    setMonth(n) {
        return this.date.setMonth(n)
    }
    setTime(n) {
        return this.date.setTime(n)
    }
    setUTCDate(n) {
        return this.date.setUTCDate(n)
    }
    setUTCFullYear(n) {
        return this.date.setUTCFullYear(n)
    }
    setUTCHours(n) {
        return this.date.setUTCHours(n)
    }
    setUTCMinutes(n) {
        return this.date.setUTCMinutes(n)
    }
    setUTCMonth(n) {
        return this.date.setUTCMonth(n)
    }
    setUTCSeconds(n) {
        return this.date.setUTCSeconds(n)
    }
    // @ts-ignore
    setYear(n) {
        return this.date.setYear(n)
    }
    // @ts-ignore
    toGMTString() {
        return this.date.toGMTString()
    }
    toISOString() {
        return this.date.toISOString()
    }
    toJSON() {
        return this.date.toJSON()
    }
    toLocaleDateString() {
        return this.date.toLocaleDateString()
    }
    toLocaleTimeString() {
        return this.date.toLocaleTimeString()
    }
    toString() {
        return this.date.toString()
    }
    toTimeString() {
        return this.date.toTimeString()
    }
    toUTCString() {
        return this.date.toUTCString()
    }
    delta({
        years = 0,
        months = 0,
        days = 0,
        hours = 0,
        minutes = 0,
        seconds = 0,
        ms = 0,
    }) {
        return new Datetime(
            this.getFullYear() + years,
            this.getMonth() + months,
            this.getDate() + days,
            this.getHours() + hours,
            this.getMinutes() + minutes,
            this.getSeconds() + seconds,
            this.getMilliseconds() + ms
        )
    }
    getDaysOfMonth() {
        return new Date(
            this.date.getFullYear(),
            this.date.getMonth() + 1,
            0
        ).getDate()
    }
    getFirstDayOfMonth() {
        return new Date(
            this.date.getFullYear(),
            this.date.getMonth(),
            1
        ).getDay()
    }
    getLastDayOfMonth() {
        return new Date(
            this.date.getFullYear(),
            this.date.getMonth(),
            this.getDaysOfMonth()
        ).getDay()
    }
    equalsYear(year) {
        return this.year === year
    }
    equalsDay(day) {
        return this.day === day
    }
    equalsMonth(month) {
        return this.month === month
    }
    equals(date) {
        if (date instanceof Datetime) {
            return (
                this.day == date.day &&
                this.month == date.month &&
                this.year == date.year
            )
        } else {
            return false
        }
    }
    values(args) {
        let ret = {
            year: this.year,
            month: this.month - 1,
            day: this.day,
            ...args,
        }
        return Object.values(ret)
    }
}

class FakeResponse {
    constructor(data, ok) {
        this.ok = ok
        this.data = data
    }
    async json() {
        return this.data
    }
}

export class JSONBin {
    endpoint = 'http://jsonbin.enio.com.ar:5000/jsonbinio/v3/b'
    
    static getURL(id=null, query={}) {
        let params = new URLSearchParams(query).toString()
        return `${this.endpoint}/${id ? "/" + id : ""}${params ? "?"+params : ""}`.replace(/([^:])(\/{2,})/g, '$1/')
    }
    
    static fetch({method='GET', id=null, data=null, params={}}) {
        return fetch(this.getURL(id, params), { method,
            headers: {
                ...(data ? {
                    'Content-Type': 'application/json'
                } : {})
            },
            ...(data ? {body: JSON.stringify(data)}:{})
        })
    }

    static save(collection, data) {
        return this.fetch({data, method: 'POST'}).then(async req => {
            console.log({ok: req.ok})
            if (req.ok) {
                let rdata = await req.json()
                let { metadata } = rdata
                window.localStorage.setItem(collection, JSON.stringify(metadata))
                return metadata.id
            } else {
                throw new Error('Error llamando al servicio')
            }
        })
        .catch(r => {
            console.log(r)
        })
    }

    static async restore(collection) {
        let meta_collecion = JSON.parse(window.localStorage.getItem(collection) || 'null')
        return meta_collecion ? this.fetch({id: meta_collecion.id, params: {meta: false}}).then(async req => {
            if(req.ok) {
                return await req.json()
            } else {
                throw new Error('Error al llamar al servicio')
            }
        })
        .catch(r => {
            console.log(r)
        }) : null
    }
}

export class JSONAth {
    // endpoint = 'https://athentotst.lacaja.com.ar/portal_proveedores/store'
    
    static getURL(collection, query={}) {
        let params = new URLSearchParams(query).toString()
        return `${API_URL}/store/${collection}/${user.value.currentIdAccount}${params ? "?"+params : ""}`.replace(/([^:])(\/{2,})/g, '$1/')
    }

    static save(collection, data) {
        return user.value?.currentIdAccount ? user.fetch(this.getURL(collection), { body: JSON.stringify(data), method: 'POST' }).then(async req => {
            if (req.ok) {
                let rdata = await req.json()
                return rdata
            } else {
                throw new Error('Error llamando al servicio.')
            }
        })
        .catch(r => {
            console.log(r)
        }) : null
    }

    static async restore(collection) {
        return user.value?.currentIdAccount ? user.fetch(this.getURL(collection)).then(async req => {
            if(req.ok) {
                return await req.json()
            } else {
                throw new Error('Error al llamar al servicio')
            }
        })
        .catch(r => {
            console.log(r)
        }) : null
    }
}